import { ArrowRight, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CtaFinal() {
  return <section data-section-id="REEMPLAZAR" id="cta-final" className="bg-background text-foreground py-16 md:py-24 lg:py-32 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,hsl(var(--primary)/0.08)_0%,transparent_60%)] pointer-events-none" />
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mx-auto rounded-2xl bg-card border-2 border-primary/30 p-8 md:p-12 lg:p-16 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-primary/10 border border-primary/20 mb-6">
            <ShieldCheck className="size-4 text-primary" />
            <span className="text-xs font-mono uppercase tracking-wider text-primary">
              Cumplimiento espontáneo · Art. 55
            </span>
          </div>
          <h2 className="font-default text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            No esperes a la <span className="text-primary font-mono">primera verificación</span>
          </h2>
          <p className="mt-6 max-w-2xl mx-auto text-lg text-slate-400 font-default leading-relaxed">
            El cumplimiento espontáneo antes de que la autoridad te visite puede reducir o eliminar sanciones — sin importar tu giro. Empieza hoy.
          </p>
          <div className="mt-10 flex flex-col items-center gap-3">
            <Link to="https://panel.notalia.app/">
              <Button size="lg" className="px-10 h-14 text-lg font-semibold bg-primary hover:bg-primary/90 text-primary-foreground transition-all duration-200">
                Empieza gratis
                <ArrowRight className="ml-2 size-5" />
              </Button>
            </Link>
            <p className="text-xs text-muted-foreground font-mono">
              14 días de Pro completo sin tarjeta. Cancela cuando quieras.
            </p>
          </div>
          <div className="mt-12 pt-8 border-t border-border/50">
            <p className="text-xs text-muted-foreground font-mono leading-relaxed max-w-xl mx-auto">
              <span className="text-primary">Art. 55 LFPIORPI reformado</span> — la SHCP puede abstenerse de sancionar si cumples de manera espontánea antes del inicio de las facultades de verificación.
            </p>
          </div>
        </div>
      </div>
    </section>;
}